import {Checkbox, Grid, Typography, FormControl, RadioGroup, FormControlLabel, Radio, DialogTitle, Dialog, DialogContent, DialogContentText, Paper} from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import UniDialog from "../Common/UniDialog";
import DestinationEditForm from "../EditOrderModal/DestinationEditForm";
import moment from "moment";
import Avatar from '@material-ui/core/Avatar';
import _ from "lodash";
import TableSection from "./TableSection";
import {handleRowValues} from "../../actions/deliveryAreaActions";
import {handleOpenDeliveryAreaFormDialog} from "../../reducers/uiSlice";
import {Autocomplete} from "@material-ui/lab";
import DialogCloseableTitle from "../Common/DialogCloseableTitle";
const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    item: {
        color: 'white'
    },
    excelMargin: {
        margin: theme.spacing(1)
    },
    formControl: {
        marginBottom: theme.spacing(1),
        minWidth: 220,
    },
    dialog: {
        overflow: 'auto',
        maxHeight: '60vh',
        '&::-webkit-scrollbar': {
            width: '7px',
            backgroundColor: 'lightgray',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'gray',
            borderRadius: '4px',
            height: '60px'
        },
    },
    styles: {
        minHeight: '10vh',
        maxHeight: '40vh',
    }
}));

function StatusDetailDialog(props) {
    const {t} = useTranslation('driverEfficiencyMonitor');
    const classes = useStyles();
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);

    useEffect(() => {
        if (!_.isEmpty(props.statusInfo) && props.detailType === 'status_detail') {
            setOpenDetailsDialog(true);
        }
    }, [props.statusInfo])

     return (
         <Dialog
             open={openDetailsDialog}
             onClose={() => {
                 setOpenDetailsDialog(false)
             }}
             maxWidth='sm'
             classes={{paper: classes.dialog}}
             fullWidth
         >
             <DialogCloseableTitle onClose={() => {
                 setOpenDetailsDialog(false)
             }}>
                 {t('order_in') + " " + props.currentState}
             </DialogCloseableTitle>
             <Paper>
                 <DialogContent>
                     <DialogContentText id="custom-dialog-description">
                         <Grid container spacing={2}>
                             <Grid
                                 container
                                 alignItems="center"
                                 justify="left"
                             >
                                 <Grid item xs={3}>
                                     <Typography variant='body2'>
                                         <span className={classes.labelTitle}>{t('driver_id')}: </span>
                                         {props.selectRowId && props.selectRowId || "N/A"}
                                     </Typography>
                                 </Grid>
                                 <Grid item xs={8}>
                                     <Typography variant='body2'>
                                         <span className={classes.labelTitle}>{t('team')}: </span>
                                         {props.selectedTeam && props.selectedTeam || "N/A"}
                                     </Typography>
                                 </Grid>
                                 <Grid item xs={4}>
                                     <Typography variant='body2'>
                                         <span className={classes.labelTitle}>{t('order_in_this_status')}: </span>
                                         {props?.statusInfo && props.statusInfo?.total_count || "N/A"}
                                     </Typography>
                                 </Grid>
                                 <Grid item xs={3}>
                                     <FormControlLabel
                                         label="Express"
                                         control={
                                             <Checkbox
                                                 color='secondary'
                                                 checked={props.selectedExpress}
                                                 disabled={true}
                                                 style={{float: "left"}}
                                             />
                                         }
                                     />
                                 </Grid>
                                 <Grid item xs={4}>
                                     <Typography variant='body2'>
                                         <span className={classes.labelTitle}>{t('partner')}: </span>
                                         {props?.partnerName && props.partnerName || "N/A"}
                                     </Typography>
                                 </Grid>
                             </Grid>
                         </Grid>
                     </DialogContentText>
                 </DialogContent>
             </Paper>
             <Paper className={classes.dialog} style={{backgroundColor: '#292929'}}>
                 <DialogContent>
                     <DialogContentText>
                         {props.statusInfo?.orders?.length > 0 && props.statusInfo?.orders?.map((orders, i) => (
                             <Grid container spacing={2}>
                                 <Grid item xs={10}>
                                     <Typography variant='body2'>
                                         <span className={classes.labelTitle}> {orders.tno}</span>
                                     </Typography>
                                 </Grid>
                                 {orders.express_type === 1 &&
                                     <Grid item xs={2}>
                                         <Typography variant='body2'>
                                             <span style={{color: 'red'}} className={classes.labelTitle}>Express</span>
                                         </Typography>
                                     </Grid>
                                 }
                             </Grid>
                         ))}
                     </DialogContentText>
                 </DialogContent>
             </Paper>
         </Dialog>
     )
}
export default StatusDetailDialog;